<template>
  <div class="autocomplete">
    <div class="input-group">
      <input class="form-control border" type="search" @input="onChange" v-model="search" />
      <span class="input-group-append">
        <button class="btn btn-outline-secondary bg-white border ms-n5" type="button">
          <span class="material-icons">search</span>
        </button>
      </span>
    </div>
    <ul id="autocomplete-results" v-show="isOpen" class="autocomplete-results">
      <template v-if="results.length > 0">
        <li v-for="(result, i) in results" :key="i" @click="setResult(result)" class="autocomplete-result">
          {{ result.isbn }} &nbsp; {{ result.title }} :&nbsp;
          {{ result.edition }}
        </li>
      </template>
      <template v-if="results.length == 0">
        <li class="autocomplete-result" id="modal-1">
          No book is matching your search criteria.<button class="btn btn-link p-0" @click="toggleModal">Click
            here</button>
          to add one...
        </li>
        <div v-show="modalActive">
          <NewBook :coursedetails="coursedetails" @close="saveBook($event)" />
        </div>

      </template>
    </ul>
    <div v-if="isSelected" class="card-component">
      <CourseCard :adoptions="this.adoptionsfromsearch" :flag="1" @useTheBook="useBook($event)" />
    </div>
  </div>
</template>

<script>
import CourseCard from "../Faculty/CourseCards.vue";
import NewBook from "../Faculty/NewBookSubmitForm.vue";
import { debounce } from "debounce";
import { ref } from "vue";
const modalActive = ref(false);
export default {
  props: {
    coursedetails: String,
  },
  setup() {

    const toggleModal = () => {
      modalActive.value = !modalActive.value;
    };
    return { modalActive, toggleModal };
  },
  data() {
    return {
      search: "",
      items: this.$store.state.searchResults,
      results: this.$store.state.searchResults,
      isOpen: false,
      isSelected: false,
      isLoading: false,
      courseObject: '',
      adoptionsfromsearch: [
        {
          bookId: null,
          book: {
            isbn: null,
            title: null,
            publisher: null,
            edition: null,
            coverPage: null,
            bookAuthors: [],
          },
        },
      ],
      sectionId: null,
    };
  },
  components: {
    CourseCard,
    NewBook
  },

  methods: {
    saveBook(event) {
      if (!event) {
        this.toggleModal();
        return;
      }
      this.$store.dispatch("saveBookAdoption", event).then((res) => {
        if (res.data.status == 200) {
          this.$emit('saveBookAdoption');
          this.toggleModal();
        }
      })
    },
    onChange: debounce(function () {
      this.filterResults();
      if (this.search == "") {
        this.isOpen = false;
        this.modalActive = false;
      } else {
        this.isOpen = true;
      }
    }, 500),
    async filterResults() {
      this.isSelected = false;
      this.sectionId = this.coursedetails;
      await this.$store.dispatch("getSearchResults", this.search);
      this.results = this.$store.state.searchResults;
    },
    enableSelect() {
      this.isOpen = false;
      this.isSelected = true;
      this.showModal = false;
    },
    async setResult(result) {
      this.search = result.isbn + "    " + result.title;
      this.adoptionsfromsearch[0].bookId = result.isbn;
      this.adoptionsfromsearch[0].book = result;
      modalActive.value = false
      this.enableSelect();
    },
    useBook(adoption) {
      let newAdoption =
      {
        sectionId: this.coursedetails,
        adoptions: [
          {
            id: 0,
            bookId: adoption.bookId,
            notes: adoption.notes,
            suggestion: parseInt(adoption.suggestion),
            isWaitToPurchase : adoption.isWaitToPurchase
            
          }
        ]
      }
      this.$emit('useTheBook', newAdoption)
    }
  },
  mounted() {
  },
};
</script>

<style>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  max-height: 120px;
  overflow: auto;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #a6abaa;
  color: white;
}

.card-component {
  background-color: #f1f9f6d6;
}
</style>
